import moment from "moment";

// const baseURL = process.env.REACT_APP_API_URL;
const baseURL = process.env.REACT_APP_API_URL;
// const baseURL = "http://192.168.1.60:8746/api/v1/";

const paths = {
  login: baseURL + "User/Login",
  userRegister: baseURL + "User/RegisterCustomer",
  forgotPassword: baseURL + "User/ForgotPassword",
  changePassword: baseURL + "AdminManager/ChangePassword",
  validateOtp: baseURL + "User/ValidateOTP",
  resendOtp: baseURL + "User/ResendOtp",
  getSwiperImage: baseURL + "User/GetLoginImages",
  projectExplore: baseURL + "Project/GetNewProjects",
  getBookingsSummary: baseURL + "Booking/GetBookingsSummary",
  paymentSummary: baseURL + "Payment/GetPaymentSummary",
  customerSiteVisit: baseURL + "Project/GetProjectsByCustomerId",
  validatetoken: baseURL + "User/ValidateToken",
  resetPassword: baseURL + "User/ResetPassword",
  projectList: baseURL + "Project/GetAllProject",
  projectDetails: baseURL + "Project/GetProjectById",
  ebwList: baseURL + "EBW/GetCustomerEbwDetailsList",
  applicantsList: baseURL + "Customer/ListCustomerApplicants",
  getApplicantById: baseURL + "Customer/GetCustomerApplicantById",
  updateApplicant: baseURL + "Customer/UpdateCustomerApplicantDetails",
  addApplicant: baseURL + "Customer/AddCustomerApplicants",
  deleteApplicant: baseURL + "Customer/DeleteCustomerApplicantByID",
  applicantDocumentList: baseURL + "Customer/GetApplicantDocumentList",
  addApplicantDocument: baseURL + "Customer/AddCustomerDocument",
  deleteApplicantDocument: baseURL + "customer/DeleteCustomerApplicantDocByID",
  addEbwCustomer: baseURL + "EBW/AddCustomerEbw",
  // addEbwCustomer: baseURL + "EBW/AddCustomerEbw",
  getRoles: baseURL + "RoleManager/Roles",
  GetRegionList: baseURL + "AdminManager/GetRegionList",
  getRegionalHeadList: baseURL + "AdminManager/GetRegionalHeadByRegionId",
  addNewUser: baseURL + "AdminManager/AddNewUser",
  getPaymentList: baseURL + "Payment/ListCustomerPayment",
  updateCustomerDetails: baseURL + "Customer/UpdateCustomerDetails",
  GetCustomerDetailsById: baseURL + "Customer/GetCustomerDetailsById",
  addProject: baseURL + "Project/AddProject",
  editProject: baseURL + "Project/UpdateProject",
  addProjectContent: baseURL + "Project/AddProjectContent",
  projectContent: baseURL + "Project/ListProjectContentByProjectId",
  editProjectContent: baseURL + "Project/UpdateProjectContent",
  deleteProjectContent: baseURL + "Project/DeleteProjectContentById",
  projectFeatures: baseURL + "Project/GetProjectFeatureById",
  addProjectFeatures: baseURL + "Project/AddProjectFeature",
  editProjectFeatures: baseURL + "Project/UpdateProjectFeature",
  deleteProjectFeatures: baseURL + "Project/DeleteProjectFeatureById",
  projectHighLight: baseURL + "Project/ListProjectHighlightByProjectId",
  addProjectHighLight: baseURL + "Project/AddProjectHighlight",
  editProjectHighLight: baseURL + "Project/UpdateProjectHighlight",
  deleteProjectHighLight: baseURL + "Project/DeleteProjectHighlightById",
  typologyByProjectId: baseURL + "Project/ListProjectTypologyByProjectId",
  typologyByProjectAndTowerId: baseURL + "Project/GetTypologyByTowerId",
  addProjectTypology: baseURL + "Project/AddProjectTypology",
  editProjectTypology: baseURL + "Project/UpdateProjectTypology",
  deleteProjectTypology: baseURL + "Project/DeleteProjectTypologyById",
  getAllTypology: baseURL + "Project/GetAllTypology",
  addEbwTypology: baseURL + "Project/AddEBWTypology",
  updateEbwTypology: baseURL + "Project/UpdateEBWTypology",
  deleteEbwTypology: baseURL + "Project/DeleteEBWTypologyById",
  projectAssets: baseURL + "Project/GetProjectAssetList",
  addProjectAsset: baseURL + "Project/AddProjectAsset",
  editProjectAsset: baseURL + "Project/UpdateProjectAsset",
  deleteProjectAsset: baseURL + "Project/DeleteProjectAssetById",
  projectCheckList: baseURL + "Project/GetProjectChecklist",
  addProjectCheckList: baseURL + "Project/AddProjectChecklist",
  editProjectCheckList: baseURL + "Project/UpdateProjectChecklist",
  deleteProjectCheckList: baseURL + "Project/DeleteProjectChecklist",
  getUsers: baseURL + "UserManagement/CurrentUsers",
  getCustomers: baseURL + "Customer/GetCustomerList",
  getUserById: baseURL + "UserManagement/GetUserById",
  // updateUser: baseURL + "User/UpdateUser",
  updateUser: baseURL + "AdminManager/UpdateUser",
  getUserByRoleName: baseURL + "AdminManager/GetAllUserByRoleName",
  userProjectList: baseURL + "UserManagement/GetUserProjectsById",
  getSfdcContacts: baseURL + "Customer/GetSFDCContacts",
  getSfdcAccount: baseURL + "Customer/GetSFDCAccountDetails",
  upsertSfdcCustomer: baseURL + "Customer/UpsertSFDCCustomerDetails",
  getCustomersbyProjectid: baseURL + "Customer/GetCustomerListByProjectId",
  getSalesUserByProjectId: baseURL + "UserManagement/GetSalesUserByProjectId",
  updateCustomer: baseURL + "Payment/UpdateCustomerPayment",
  getCustomersWaitingList: baseURL + "Customer/GetCustomersWaitingList",
  getAssignQueListById: baseURL + "Customer/GetSalesPersonQueueList",
  assignCustomer: baseURL + "Customer/AssignSalesPerson",
  GetCustomerByCustomerAndProjectId:
    baseURL + "Customer/GetCustomerByCustomerAndProjectId",
  addCustomerNote: baseURL + "Customer/AddCustomerNotes",
  getNoteList: baseURL + "Customer/GetNotesListByID",
  meetingInvite: baseURL + "Customer/AddCustomerProjectMeeting",
  getSourcingTeamLeadList: baseURL + "UserManagement/GetSourcingTeamLeadList",
  salePersonStatus: baseURL + "Customer/AddSalesPersonStatus",
  getAssetByProjectId: baseURL + "Project/GetProjectAssetsByAssetId",
  assetTypelist: baseURL + "Project/GetAssetTypeList",
  getTowerData: baseURL + "Project/GetSFDCTowerDetails",
  getPropertyDetails: baseURL + "Project/GetSFDCPropertyDetails",
  validateCustomerEbwNumber: baseURL + "EBW/ValidateCustomerEbwNumber",
  removeCustomerFromQueue: baseURL + "Customer/RemoveCustomerFromQueue",
  paymentCallBackUrl: baseURL + "User/CallBackURL",
  getCustomersList: baseURL + "Customer/GetCustomerPaginatedListByProjectId",
  getCustomersForSp: baseURL + "Customer/GetCustomersForSalesPerson",
  addSalesEbw: baseURL + "EBW/AddCustomerEbwToSalePerson",
  getEbwList: baseURL + "Ebw/ListCustomerEbwDetailsByProjectID",
  getEbwForSalePerson: baseURL + "EBW/ListCustomerEbwForSalePerson",
  getSpPaymentList: baseURL + "Payment/ListCustomerPaymentByProjectId",
  getPaymentListForSp: baseURL + "Payment/ListCustomerPaymentForSalePerson",
  apartmentList: baseURL + "Project/GetSFDCAllApartment",
  spPaymentShedule: baseURL + "Project/GetSFDCPaymentPlanDetails",
  getTowerListByProjectId: baseURL + "Project/GetTowerListByProjectId",
  updateTowerEBA: baseURL + "Project/UpdateProjectTower",
  addScheme: baseURL + "Project/AddAdjustmentScheme",
  getScheme: baseURL + "Project/GetSchemesList",
  getSchemeById: baseURL + "Project/GetSchemeBySchemeId",
  deleteScheme: baseURL + "Project/DeleteSchemeById",
  checkApproveDisapprove: baseURL + "Project/CheckApprovedOrNotApprovedRequest",
  // approveDisapproveScheme: baseURL + "Project/ApproveDisapproveRequest",
  approveDisapproveScheme: baseURL + "Project/ApproveRejectRequest",
  getSupportingDocuments: baseURL + "Booking/GetBookingsDocumentsList",
  uploadSupportingBookingDocument: baseURL + "Booking/AddBookingsDocuments",
  deleteSupportingBookingDocument:
    baseURL + "Booking/DeleteBookingDocumentByID",
  getBookingListByProjectId: baseURL + "Booking/GetBookingDetailsList",
  getParkingList: baseURL + "Project/GetParkingByProjectId",
  addParking: baseURL + "Project/AddProjectParking",
  updateParking: baseURL + "Project/Project/UpdateProjectParking",
  deleteParking: baseURL + "Project/DeleteProjectParking",
  bookingOtp: baseURL + "Booking/BookingOTP",
  verifyBookingOtp: baseURL + "Booking/VerifyBookingOTP",
  bookingDetailbyId: baseURL + "Booking/GetBookingById",
  getUpdateAddress: baseURL + "Booking/GetBookingAddressById",
  addUpdateAddress: baseURL + "Booking/AddBookingAddresses",
  getQuatation: baseURL + "Project/GetQuotation",
  // addBooking: baseURL + `Booking/AddBookings`,
  // sendQuatation: baseURL + "Booking/SendQuatationPdf",
  sendQuatation: baseURL + "Project/SendQuotationPdf",
  getPropertyCharges: baseURL + "Project/GetSFDCPropertyTypeDetails",
  // addBooking: baseURL + `Booking/AddCustomerBookings`,
  addBooking: baseURL + `Booking/AddCustomerConfirmBookings`,
  addUnconfirmBooking: baseURL + `Booking/AddCustomerUnconfirmBookings`,
  updateConfirmBooking: baseURL + `Booking/UpdateConfirmBooking`,
  getProjectBySfdc: baseURL + `project/GetSFDCProjectDetails`,
  getSFDCDocumentStorage: baseURL + "Project/GetSFDCDocumentStorage",
  getEBWPaymentList: baseURL + "Payment/GetCustomerPaymentsList",
  updatePaymentSatus: baseURL + "Payment/UpdateCustomerPaymentStatus",
  approveRejectByCrm: baseURL + "Booking/ApproveRejectBookingByCRM",
  getAllCRMChecklist: baseURL + "Booking/GetAllCRMChecklist",
  getAllEbwList: baseURL + "EBW/GetAllEBWList",
  getBookingForCustomer: baseURL + "Booking/GetBookingByCustomerId",
  getSyncBooking: baseURL + "Booking/GetSyncBooking",
  updateCustomerPaymentStatus: baseURL + "Payment/UpdateCustomerPaymentStatus",
  bookingPdf: baseURL + "Booking/GetPdfBindingData",
  getParkings: baseURL + "Project/GetSFDCCarParkingList",
  sendBookingPdf: baseURL + "Booking/SendBookingPdf",
  // sendBookingPdf: baseURL + "Booking/BookingForm",
  bookingPaymentStatus: baseURL + "Booking/CheckBookingPaymentStatus",
  syncBooking: baseURL + "Booking/SyncBooking",
  bookingResendOtp: baseURL + "Booking/ResendBookingOtp",
  realseUnit: baseURL + "Booking/ReleaseBookings",
  SendBookingToCRM: baseURL + "Booking/SendBookingToCRM",
  upsertPayments: baseURL + "Payment/UpsertPayments",
  // grapgh and tables api
  BandWiseDataByProjectId: baseURL + "Project/BandWiseDataByProjectId",
  GetAllDataByProjectId: baseURL + "Project/GetAllDataByProjectId",
  getApr: baseURL + "Project/GetAPRValueByProjectId",
  getActiveCp: baseURL + "EBW/GetActiveCPs",
  GetEnquiryType: baseURL + "EBW/GetEnquiryTypeCount",
  GetSiteVisitCount: baseURL + "EBW/GetSitevisitCount",
  projectInterested: baseURL + "Project/ProjectInterested",
  deleteBooking: baseURL + "Booking/DeleteBookingByID",
  getPaymentOrderId: baseURL + "EBW/GetPaymentOrderId",
  rejectedHistory: baseURL + "Booking/GetBookingRejectedHistory",
  logOut: baseURL + "User/Logout",
  checkAccess: baseURL + "User/CheckAccess",
  getExportData: baseURL + "EBW/GetExportToExcel",
  syncHistory: baseURL + "Booking/GetBookingSyncHistory",
  EbwLost: baseURL + "EBW/EbwLost",
  addRequest: baseURL + "Booking/addRequest",
  getUserRequests: baseURL + "Booking/GetRequests",
  getRequestedCustomers: baseURL + "Booking/GetRequestCustomers",
  editUserRequest: baseURL + "Booking/UpdateUserRequest",
  getUserRole: baseURL + "User/GetUserRoleByEmail",
  getBookingAplicants: baseURL + "Booking/GetBookingApplicantByBookingId",
  deleteBookingApplicant: baseURL + "Booking/DeleteBookingApplicant",
  updateBookingApplicant: baseURL + "Booking/UpdateBookingApplicant",
  getBankList: baseURL + "Booking/GetBankList",
  deleteBank: baseURL + "Booking/DeleteBank",
  upsertBank: baseURL + "Booking/UpsertBank",
  deleteUser: baseURL + "AdminManager/DeleteUser",
  // getAllCounts: baseURL + "UserManagement/GetAllCounts",
  getAllCounts: baseURL + "User/GetAllCounts",
  addBookingSwap: baseURL + "Booking/AddBookingSwap",
  customerSiteVisitDetails: baseURL + "Customer/CustomerSiteVisitDetails",
  countryAndStateList: baseURL + "Common/GetCountryAndStateList",
  getSmsEmails: baseURL + "project/GetCommunicationLogList",
  getSmsEmailsDetails: baseURL + "project/GetCommunicationLogById",
  getSmsEmailsCounts: baseURL + "project/GetCommunicationLogCount",
  paymentReceipt: baseURL + "Payment/GetPaymentDetailsById",
  generateOtpForUpsert: baseURL + "User/GenerateOtp",
  GetSFDCCustomerDetails: baseURL + "Customer/GetSFDCCustomerDetails",
  updateBookingPaymentPlan: baseURL + "Booking/UpdateBookingPaymentPlan",
  setCommunicationMedia: baseURL + "Customer/SetCommunicationMedia",
  UpdateCustomerPersonalDetails:
    baseURL + "Customer/UpdateCustomerPersonalDetails",
  updateLogs: baseURL + "Customer/GetCustomerUpdateLog",
  sendBookingReport: baseURL + "Booking/SendBookingReport",
  upsertProjectPlotPhase: baseURL + "Project/UpsertProjectTower",
  sendPaymentReport: baseURL + "Payment/SendPaymentReport",
  addPlotCoordinates: baseURL + "Project/AddPlotCoordinates",
  getPlotCoordinatesFetching: baseURL + "Project/GetPlotCoordinatesByProjectId",
  sendMasterReport: baseURL + "Project/SendMasterReport",
  upsertProjectPhases: baseURL + "Project/UpsertProjectPhases",
  getProjectPhasesByProjectId: baseURL + "Project/GetProjectPhasesByProjectId",
  deleteProjectPhases: baseURL + "Project/DeleteProjectPhases",
  deletePlotCoordinates: baseURL + "Project/DeletePlotCoordinates",
  sendCustomerLeadReport: baseURL + "Customer/SendCustomerLeadReport",
  sendEbwReport: baseURL + "EBW/SendEbwReport",
  sendUserReport: baseURL + "User/SendUserReport",
  sendCustomerReport: baseURL + "Customer/SendCustomerReport",
  sendSFDCApartmentReport: baseURL + "Project/SendSFDCApartmentReport",
  GetTlSiteVisitCount: baseURL + "Dashboard/GetClosingTeamLeadDataByProjectId",
  GetTlSiteVisitBydate: baseURL + "Dashboard/GetClosingTeamLeadDataById",
  removeClosingManager: baseURL + "Customer/RemoveClosingManager",
  getProjectOtherDocuments: baseURL + "Project/GetProjectOtherDocument",
  addUpdateProjectOtherDocument: baseURL + "Project/UpsertProjectOtherDocument",
  deleteProjectOtherDocuemnt: baseURL + "Project/DeleteProjectOtherDocument",
  upsertApplicant: baseURL + "Customer/UpsertCustomerApplicant",
  bulkAssignCustomer: baseURL + "Customer/BulkAssignSalesPerson",
  getSsoToken: baseURL + "User/GetSsoToken",
  getCommentsList: baseURL + "Booking/GetBookingCommentHistory",
  getApplicantKYCDetailsById: baseURL + "Digio/GetKycDetailsByApplicantId",
  updateApplicantKycDetails: baseURL + "Customer/UpdateApplicantKycDetails",
  editManualKycRequest: baseURL + "Customer/UpdateManualKycRequest",
  getManualKycRequests: baseURL + "Customer/GetManualKycRequests",
  getNotifications: baseURL + "Notification/GetCurrentUserNotification",
  updateNotificationStatus: baseURL + "Notification/UpdateNotificationStatus",
};

const createEndpoint = (apiName, query = "") => {
  let apiPath = paths[apiName];
  return apiPath + query;
};

const getEndpoint = (apiName, pathVars) => {
  const apiPath = paths[apiName];
  const joinParams = pathVars.map((item) => {
    return `${item.pathName}=${item.pathValue}`;
  });

  return joinParams?.length > 0
    ? `${apiPath}?${joinParams.join("&")}`
    : apiPath;
};

const validateToken = (name, token) => {
  return getEndpoint(name, [{ pathName: "token", pathValue: token }]);
};

const getAllProjects = (name, location, status, pageNo, pageSize) => {
  const params =
    location !== "" && status !== ""
      ? [
          { pathName: "location", pathValue: location },
          { pathName: "status", pathValue: status },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: pageSize },
        ]
      : location !== ""
        ? [
            { pathName: "location", pathValue: location },
            { pathName: "pageNumber", pathValue: pageNo },
            { pathName: "pageSize", pathValue: pageSize },
          ]
        : status !== ""
          ? [
              { pathName: "status", pathValue: status },
              { pathName: "pageNumber", pathValue: pageNo },
              { pathName: "pageSize", pathValue: pageSize },
            ]
          : [
              { pathName: "pageNumber", pathValue: pageNo },
              { pathName: "pageSize", pathValue: pageSize },
            ];
  return getEndpoint(name, params);
};

const getSchemeListForAdmin = (name, bookingId, projectId, towerId, status) => {
  const params =
    bookingId !== "" && projectId !== "" && towerId !== "" && status !== ""
      ? [
          { pathName: "bookingId", pathValue: bookingId },
          { pathName: "projectId", pathValue: projectId },
          { pathName: "towerId", pathValue: towerId },
          { pathName: "status", pathValue: status },
        ]
      : bookingId !== "" && projectId !== "" && towerId !== ""
        ? [
            { pathName: "bookingId", pathValue: bookingId },
            { pathName: "projectId", pathValue: projectId },
            { pathName: "towerId", pathValue: towerId },
          ]
        : [];

  return getEndpoint(name, params);
};
const getSchemeListForSales = (
  name,
  bookingId,
  projectId,
  typologyName,
  towerId,
  customerId,
  apartmentName,
) => {
  const params =
    bookingId !== "" &&
    projectId !== "" &&
    towerId !== "" &&
    customerId !== "" &&
    apartmentName !== ""
      ? [
          { pathName: "bookingId", pathValue: bookingId },
          { pathName: "projectId", pathValue: projectId },
          { pathName: "typologyName", pathValue: typologyName },
          { pathName: "towerId", pathValue: towerId },
          { pathName: "customerId", pathValue: customerId },
          { pathName: "apartmentName", pathValue: apartmentName },
        ]
      : [];

  return getEndpoint(name, params);
};

const getApplicants = (name, customerId, bookingId) => {
  const params =
    customerId !== ""
      ? [{ pathName: "customerId", pathValue: customerId }]
      : bookingId !== ""
        ? [{ pathName: "bookingId", pathValue: bookingId }]
        : [];
  return getEndpoint(name, params);
};

const getCountryAndState = (name, parentLocationId, locationType) => {
  const params =
    locationType !== "" && parentLocationId == ""
      ? [{ pathName: "locationType", pathValue: locationType }]
      : parentLocationId !== "" && locationType !== ""
        ? [
            { pathName: "parentLocationId", pathValue: parentLocationId },
            { pathName: "locationType", pathValue: locationType },
          ]
        : [];
  return getEndpoint(name, params);
};

const GetCustomerDetailsById = (name, customerId) => {
  const params =
    customerId !== ""
      ? [{ pathName: "customerId", pathValue: customerId }]
      : [];
  return getEndpoint(name, params);
};

const getPaymentList = (name, customerId, projectId, pageNo, pageSize) => {
  const params =
    customerId !== ""
      ? [
          { pathName: "data.customerId", pathValue: customerId },
          { pathName: "data.projectId", pathValue: projectId },
        ]
      : [
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: pageSize },
        ];
  return getEndpoint(name, params);
};

const getPropertyChargesEndpoint = (name, propertyName, propertyId) => {
  const params = [
    { pathName: "propertyName", pathValue: propertyName },
    { pathName: "propertyId", pathValue: propertyId },
  ];
  return getEndpoint(name, params);
};

const getQuatationEndpoint = (
  name,
  towerId,
  projectId,
  aggrementValue,
  typologyName,
  propertyName,
  propertyId,
  superArea,
  ebwNumber,
) => {
  const params = [
    { pathName: "towerId", pathValue: towerId },
    { pathName: "projectId", pathValue: projectId },
    { pathName: "agreementValue", pathValue: aggrementValue },
    { pathName: "typologyName", pathValue: typologyName },
    { pathName: "propertyName", pathValue: propertyName },
    { pathName: "propertyId", pathValue: propertyId },
    { pathName: "superArea", pathValue: superArea },
    { pathName: "ebwNumber", pathValue: ebwNumber },
  ];
  return getEndpoint(name, params);
};

const getEbwWithPagination = (name, projectId, pageNo, rowsPerPage) => {
  const params = [
    { pathName: "projectId", pathValue: projectId },
    { pathName: "pageNumber", pathValue: pageNo },
    { pathName: "pageSize", pathValue: rowsPerPage },
  ];
  return getEndpoint(name, params);
};

const getSyncDataWithPagination = (
  name,
  id,
  pageNo,
  rowsPerPage,
  type,
  projectId,
) => {
  const params =
    type == "customer"
      ? [
          {
            pathName: "customerId",
            pathValue: id,
          },
          {
            pathName: "projectId",
            pathValue: projectId,
          },
          // { pathName: "searchTerm", pathValue: searchInput },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : [
          {
            pathName: "bookingId",
            pathValue: id,
          },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const getDataWithPagination = (
  name,
  projectId,
  searchInput,
  pageNo,
  rowsPerPage,
  type,
) => {
  const params =
    searchInput !== null
      ? [
          {
            pathName: type == "syncHistory" ? "bookingId" : "projectId",
            pathValue: projectId,
          },
          { pathName: "searchTerm", pathValue: searchInput },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : [
          {
            pathName: type == "syncHistory" ? "bookingId" : "projectId",
            pathValue: projectId,
          },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const getDataWithPaginationWithoutProject = (
  name,
  searchInput,
  pageNo,
  rowsPerPage,
  filterObj,
) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName: elem?.label == "searchInput" ? "searchTerm" : `${elem?.label}`,
      pathValue:
        elem?.label == "createdAt"
          ? moment(elem?.value)?.format("YYYY-MM-DD")
          : elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : //  searchInput !== null
        //   ? [
        //       { pathName: "searchTerm", pathValue: searchInput },
        //       { pathName: "pageNumber", pathValue: pageNo },
        //       { pathName: "pageSize", pathValue: rowsPerPage },
        //     ]
        //   :
        [
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const checkschemesById = (
  name,
  projectId,
  projectTowerId,
  typologyId,
  status,
) => {
  const params =
    status !== null
      ? [
          { pathName: "projectId", pathValue: projectId },
          { pathName: "projectTowerId", pathValue: projectTowerId },
          { pathName: "typologyId", pathValue: typologyId },
          { pathName: "status", pathValue: status },
        ]
      : [
          { pathName: "projectId", pathValue: projectId },
          { pathName: "projectTowerId", pathValue: projectTowerId },
          { pathName: "typologyId", pathValue: typologyId },
        ];
  return getEndpoint(name, params);
};

const getProjectbyId = (name, id) => {
  return getEndpoint(name, [{ pathName: "projectId", pathValue: id }]);
};

const getProjectDetailsbyId = (name, id) => {
  return getEndpoint(name, [{ pathName: "projectId", pathValue: id }]);
};

// const

const getBookings = (name, id, status, pageNo, rowsPerPage, searchInput) => {
  const params =
    id == "" && status == "" && searchInput !== null
      ? [
          { pathName: "data.searchTerm", pathValue: searchInput },
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ]
      : id == "" && status == ""
        ? [
            { pathName: "data.pageNumber", pathValue: pageNo },
            { pathName: "data.pageSize", pathValue: rowsPerPage },
          ]
        : searchInput !== null
          ? [
              { pathName: "data.projectId", pathValue: id },
              { pathName: "data.status", pathValue: status },
              { pathName: "data.pageNumber", pathValue: pageNo },
              { pathName: "data.pageSize", pathValue: rowsPerPage },
              { pathName: "data.searchTerm", pathValue: searchInput },
            ]
          : status !== ""
            ? [
                { pathName: "data.projectId", pathValue: id },
                { pathName: "data.status", pathValue: status },
                { pathName: "data.pageNumber", pathValue: pageNo },
                { pathName: "data.pageSize", pathValue: rowsPerPage },
              ]
            : [
                { pathName: "data.projectId", pathValue: id },
                { pathName: "data.pageNumber", pathValue: pageNo },
                { pathName: "data.pageSize", pathValue: rowsPerPage },
              ];
  return getEndpoint(name, params);
};
const getBookingDetailsList = (name, id, status, pageNo, rowsPerPage) => {
  const params =
    id !== null && status !== null
      ? [
          { pathName: "data.projectId", pathValue: id },
          { pathName: "data.status", pathValue: status },
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ]
      : [
          { pathName: "data.projectId", pathValue: id },
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const GetCustomerApplicantById = (name, id, bookingApplicantId = 0) => {
  return getEndpoint(
    name,
    bookingApplicantId
      ? [
          { pathName: "customerApplicantId", pathValue: id },
          { pathName: "bookingApplicantId", pathValue: bookingApplicantId },
        ]
      : [{ pathName: "customerApplicantId", pathValue: id }],
  );
};
// const GetSfdcContactDetails = (name, email, mobileNumber) => {
//   return getEndpoint(name, [
//     { pathName: "mailId", pathValue: email },
//     { pathName: "mobileNumber", pathValue: mobileNumber },
//   ]);
// };

const getCustomerFetchingDetails = (name, selectedProject, searchTerm) => {
  return getEndpoint(name, [
    { pathName: "projectId", pathValue: selectedProject },
    { pathName: "searchTerm", pathValue: searchTerm },
  ]);
};
const GetPaymentCallBackUrl = (name, payload) => {
  return getEndpoint(name, [
    {
      pathName: "razorpay_payment_link_reference_id",
      pathValue: payload?.payment_link_reference_id,
    },
    {
      pathName: "razorpay_payment_id",
      pathValue: payload?.razorpay_payment_id,
    },
    {
      pathName: "razorpay_payment_link_status",
      pathValue: payload?.payment_link_status,
    },
    { pathName: "razorpay_payment_link_id", pathValue: payload?.paymentLinkId },
    { pathName: "razorpay_signature", pathValue: payload?.razorpaySignature },
  ]);
};
const GetSfdcAccountDetails = (name, email, brokarCode) => {
  return getEndpoint(name, [
    { pathName: "email", pathValue: email },
    { pathName: "brokarCode", pathValue: brokarCode },
  ]);
};

const getEbwFilterRequest = (name, id, pageNo, rowsPerPage, filterObj) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName:
        elem?.label == "ebwNumber" ||
        elem?.label == "paymentStatus" ||
        elem?.label == "searchInput"
          ? "searchTerm"
          : elem?.label,
      pathValue: elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "projectId", pathValue: id },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : [
          { pathName: "projectId", pathValue: id },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const getFilterRequest = (name, id, pageNo, rowsPerPage, filterObj) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName:
        elem?.label == "searchInput"
          ? "data.searchTerm"
          : `data.${elem?.label}`,
      pathValue:
        elem?.label == "dateOfClearance" ||
        elem?.label == "transactionDate" ||
        elem?.label == "issuanceOfDate"
          ? moment(elem?.value)?.format("YYYY-MM-DD")
          : elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "data.projectId", pathValue: id },
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ]
      : [
          { pathName: "data.projectId", pathValue: id },
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};
const getFilterRequestWithotProjectId = (
  name,
  pageNo,
  rowsPerPage,
  filterObj,
) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName: `data.${elem?.label}`,
      pathValue:
        elem?.label == "dateOfClearance" ||
        elem?.label == "transactionDate" ||
        elem?.label == "issuanceOfDate"
          ? moment(elem?.value)?.format("YYYY-MM-DD")
          : elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ]
      : [
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const getFilterDataWithPagination = (
  name,
  projectId,
  searchInput,
  pageNo,
  rowsPerPage,
  filterObj,
  type,
) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName: elem?.label == "searchInput" ? "searchTerm" : `${elem?.label}`,
      pathValue:
        elem?.label == "createdAt"
          ? moment(elem?.value)?.format("YYYY-MM-DD")
          : elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          {
            pathName: type == "syncHistory" ? "bookingId" : "projectId",
            pathValue: projectId,
          },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : // searchInput !== null
        //   ? [
        //       {
        //         pathName: type == "syncHistory" ? "bookingId" : "projectId",
        //         pathValue: projectId,
        //       },
        //       { pathName: "searchTerm", pathValue: searchInput },
        //       { pathName: "pageNumber", pathValue: pageNo },
        //       { pathName: "pageSize", pathValue: rowsPerPage },
        //     ]
        //   :
        [
          {
            pathName: type == "syncHistory" ? "bookingId" : "projectId",
            pathValue: projectId,
          },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const getBookingFilterRequest = (
  name,
  id,
  status,
  pageNo,
  rowsPerPage,
  filterObj,
  searchInput,
) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName:
        elem?.label == "searchInput"
          ? "data.searchTerm"
          : `data.${elem?.label}`,
      pathValue:
        elem?.label == "dateOfClearance" ||
        elem?.label == "transactionDate" ||
        elem?.label == "issuanceOfDate"
          ? moment(elem?.value)?.format("YYYY-MM-DD")
          : elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "data.projectId", pathValue: id },
          { pathName: "data.status", pathValue: status },
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ]
      : //  searchInput !== null
        //   ? [
        //       { pathName: "data.searchTerm", pathValue: searchInput },
        //       { pathName: "data.projectId", pathValue: id },
        //       { pathName: "data.status", pathValue: status },
        //       { pathName: "data.pageNumber", pathValue: pageNo },
        //       { pathName: "data.pageSize", pathValue: rowsPerPage },
        //     ]
        //   :
        [
          { pathName: "data.projectId", pathValue: id },
          { pathName: "data.status", pathValue: status },
          { pathName: "data.pageNumber", pathValue: pageNo },
          { pathName: "data.pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};
const getUserRequestList = (name, id, type, pageNo, rowsPerPage, filterObj) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName: elem?.label == "searchInput" ? "searchTerm" : elem?.label,
      pathValue: elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "projectId", pathValue: id },
          { pathName: "requestType", pathValue: type },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : [
          { pathName: "projectId", pathValue: id },
          { pathName: "requestType", pathValue: type },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const getManualKycRequestList = (name, id, pageNo, rowsPerPage, filterObj) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName: elem?.label == "searchInput" ? "searchTerm" : elem?.label,
      pathValue: elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "projectId", pathValue: id },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : [
          { pathName: "projectId", pathValue: id },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

const getSMSEmailsList = (
  name,
  id,
  type,
  pageNo,
  rowsPerPage,
  filterObj,
  searchInput,
) => {
  const createQuery = filterObj?.map((elem) => {
    return {
      pathName: elem?.label == "searchInput" ? "content" : elem?.label,
      pathValue: elem?.value,
    };
  });
  const params =
    filterObj?.length > 0
      ? [
          ...createQuery,
          { pathName: "projectId", pathValue: id },
          { pathName: "type", pathValue: type },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ]
      : // :

        // searchInput !== null
        //   ? [
        //       { pathName: "projectId", pathValue: id },
        //       { pathName: "type", pathValue: type },
        //       { pathName: "pageNumber", pathValue: pageNo },
        //       { pathName: "pageSize", pathValue: rowsPerPage },
        //       { pathName: "content", pathValue: searchInput },
        //     ]
        [
          { pathName: "projectId", pathValue: id },
          { pathName: "type", pathValue: type },
          { pathName: "pageNumber", pathValue: pageNo },
          { pathName: "pageSize", pathValue: rowsPerPage },
        ];
  return getEndpoint(name, params);
};

export {
  createEndpoint,
  getEndpoint,
  paths,
  validateToken,
  getAllProjects,
  getProjectDetailsbyId,
  GetCustomerApplicantById,
  getCustomerFetchingDetails,
  GetSfdcAccountDetails,
  getProjectbyId,
  getDataWithPagination,
  GetPaymentCallBackUrl,
  getApplicants,
  getPaymentList,
  getEbwWithPagination,
  checkschemesById,
  getBookings,
  GetCustomerDetailsById,
  getQuatationEndpoint,
  getPropertyChargesEndpoint,
  getSchemeListForAdmin,
  getSchemeListForSales,
  getDataWithPaginationWithoutProject,
  getBookingDetailsList,
  getUserRequestList,
  getManualKycRequestList,
  getFilterRequest,
  getBookingFilterRequest,
  getCountryAndState,
  getFilterDataWithPagination,
  getSMSEmailsList,
  getSyncDataWithPagination,
  getFilterRequestWithotProjectId,
  getEbwFilterRequest,
};
